export const environment = {
    production: false,
    apis: {
        employerApi: 'https://app-fagf-employer-dev.azurewebsites.net',
      },
    azureB2C: {
      clientId: '1ed89361-5597-4c54-a4d0-a7e644e766d8',
      // clientId: 'd7264c34-9585-4060-9a0f-88440b9731f4',
      authority: 'https://fagforbundetb2cstage.b2clogin.com/fagforbundetb2cstage.onmicrosoft.com/b2c_1_dtpsignicatdev',
      knownAuthorities: ['fagforbundetb2cstage.b2clogin.com'],
      redirectUri: 'https://arbeidsgiver-dev.fagforbundet.dev',
      postLogoutRedirectUri: 'https://arbeidsgiver-dev.fagforbundet.dev/auth',
      domain: 'fagforbundetb2cstage.onmicrosoft.com',
    },
  };